import { render, staticRenderFns } from "./myVisit.vue?vue&type=template&id=27371b64&scoped=true"
import script from "./myVisit.vue?vue&type=script&lang=js"
export * from "./myVisit.vue?vue&type=script&lang=js"
import style0 from "./myVisit.vue?vue&type=style&index=0&id=27371b64&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27371b64",
  null
  
)

export default component.exports